module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_5.736def05.jpg";